import { NSALoginPage } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import SupportChannels from "../components/SupportChannels";
import { NSSpace, NSSpaceSizeType } from "namirasoft-site-react";

function LoginPage()
{
	return (
		<NSALoginPage
			product_id={ProductUUID.NAMIRASOFT_SUPPORT}
		>
			<>
				<NSSpace size={NSSpaceSizeType.LARGE} />
				<SupportChannels
					ticket={false}
					chat
					email
					meeting={false}
				/>
			</>
		</NSALoginPage>
	);
}

export default LoginPage;